import { GAINSIGHT_PX_FUNCTION_NAME } from 'constants/AppConstants';

// #genai
// Attributes are limited to the set approved in the Gainsight Data Field Review.
// Adding a field here requires a documented business justification in that review.
export const gainsightPxIdentifyUser = (userprofile) => {
  const organization = userprofile?.organization;

  if (typeof window[GAINSIGHT_PX_FUNCTION_NAME] === 'function' && userprofile?.userId && organization?.id) {
    window[GAINSIGHT_PX_FUNCTION_NAME]('identify', {
      id: userprofile.userId,
      email: userprofile.email,
      state: userprofile.address?.state,
    }, {
      id: organization.id,
      name: organization.name,
      sfdcId: organization.salesforceId,
      state: organization.address?.state,
      businessSegment: organization.businessSegment,
      industry: organization.industry,
    });
  }
};

export const gainsightPxCustomEvent = (eventName, eventData) => {
  if (typeof window[GAINSIGHT_PX_FUNCTION_NAME] === 'function') {
    window[GAINSIGHT_PX_FUNCTION_NAME]('track', eventName, eventData);
  }
};
